import * as React from 'react'
import { Site } from '@envato/foundation-types'

import { IItem } from 'searchResults'

import Card from '../../categoryPage/elementsPromoItemsBlock/card/card'
import AudioCard from '../../categoryPage/elementsPromoItemsBlock/audioCard/audioCard'
import { getCurrentSiteFromDomain } from '../../../../common/utils/sites'
import { IHomePageBlockComponent } from '../../../../typings/pageBlocks'

import * as styles from './freeItemsBlock.module.css'

interface IProps extends IHomePageBlockComponent {
  data: IItem[]
  title: string
  subtitle?: string
  reportItemClick: (index: number, item: IItem, listName: string) => any
}

const siteToTypeMap = new Map([
  [Site.themeforest, 'Web Templates'],
  [Site.graphicriver, 'Graphics'],
  [Site.audiojungle, 'Audio'],
  [Site.videohive, 'Video'],
  [Site.photodune, 'Photos'],
  [Site.codecanyon, 'Code'],
  [Site.threedocean, '3D Files']
])

const FreeItemsBlock = ({ data, title, subtitle, reportItemClick }: IProps) => {
  const itemsWithRatios = data.map(item => ({
    ...item,
    imageRatios: {
      previewRatio: 300 / 590
    },
    marketID: 0,
    title: item.name,
    author: item.author_username,
    itemURL: item.url
  }))

  return (
    <section
      id="free-items-section"
      className={styles.root}
      data-test-selector="freeItemsBlock"
    >
      <div className={styles.wrapper}>
        <header className={styles.header}>
          <h2 className={styles.title}>{title}</h2>
          {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
        </header>
        <div className={styles.items}>
          {itemsWithRatios.map((item, index) => {
            const isAudioItem = item.site === 'audiojungle.net'
            const siteName = getCurrentSiteFromDomain(item.site)
            const categoryName = siteName && siteToTypeMap.get(siteName)
            const width = index > 2 ? 25 : 33.33

            const onClickHandler = () =>
              reportItemClick(index, item, 'Homepage: Free files of the month')

            return (
              <div className={styles.item} key={index}>
                {isAudioItem ? (
                  <AudioCard
                    {...item}
                    width={width}
                    onClick={onClickHandler}
                    showCTA={false}
                    categoryName={categoryName}
                  />
                ) : (
                  <Card
                    {...item}
                    width={width}
                    onClick={onClickHandler}
                    showCTA={false}
                    categoryName={categoryName}
                  />
                )}
              </div>
            )
          })}
        </div>
      </div>
    </section>
  )
}

export default FreeItemsBlock
